class PBBeforeAfter extends HTMLElement {
  connectedCallback() {
    this.wrapper = this.querySelector('[data-pb-ba-wrapper]');
    this.slider = this.querySelector('.pb-ba__range');
    if (!this.wrapper || !this.slider) return;

    this.onInput = this.onInput.bind(this);
    this.slider.addEventListener('input', this.onInput);
    this.sync();

    if (this.dataset.intro === 'true') this.setupIntro();
  }

  disconnectedCallback() {
    if (this.slider) this.slider.removeEventListener('input', this.onInput);
    if (this.observer) this.observer.disconnect();
  }

  onInput() {
    this.sync();
  }

  sync() {
    this.wrapper.style.setProperty('--compare', String(this.slider.value));
  }

  setupIntro() {
    if (!('IntersectionObserver' in window)) return;
    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            this.observer.disconnect();
            this.playIntro();
          }
        }
      },
      { threshold: 0.5 }
    );
    this.observer.observe(this);
  }

  playIntro() {
    if (this.played) return;
    this.played = true;

    const w = this.wrapper;
    const set = (value) => w.style.setProperty('--compare', String(value));

    w.style.setProperty('--transition-duration', '0.7s');
    set(100); // reveal "før" fully — handle all the way right
    setTimeout(() => set(0), 850); // sweep to "efter" fully — handle all the way left
    setTimeout(() => set(50), 1750); // settle in the middle
    setTimeout(() => {
      w.style.setProperty('--transition-duration', '0s');
      this.slider.value = '50';
    }, 2550);
  }
}

if (!customElements.get('pb-before-after')) {
  customElements.define('pb-before-after', PBBeforeAfter);
}
